<template>
  <div id="aInspectionRouteMap" class="map-container"></div>
</template>

<script>
import { listAdminInspectionRoutePoints } from '@/api/inspection/aInspectionPlanDetailApi'
import { loadTianditu } from '@/utils/tianditu'
import { storeToTianditu } from '@/utils/coordTransform'

export default {
  name: 'AInspectionRouteMap',
  data() {
    return {
      map: null,
      points: [],
      markers: [],
      polyline: null,
      storeCoord: 'GCJ02'
    }
  },
  beforeDestroy() {
    this.clearOverlays()
    this.map = null
  },
  methods: {
    async initMap(params) {
      try {
        const { data } = await listAdminInspectionRoutePoints({
          inspectionRouteId: params.inspectionRouteId,
          page: 1,
          row: 1000
        })
        this.points = data || []
        const { T, config } = await loadTianditu()
        this.storeCoord = config.STORE_COORD || 'GCJ02'
        this.renderMap(T)
      } catch (error) {
        console.error(error)
        this.$message && this.$message.error(this.$t('common.fetchError'))
      }
    },
    renderMap(T) {
      this.clearOverlays()
      if (!this.points || this.points.length === 0) return
      const dom = document.getElementById('aInspectionRouteMap')
      if (!dom) return

      const first = storeToTianditu(this.points[0].lng, this.points[0].lat, this.storeCoord)
      this.map = new T.Map(dom)
      this.map.centerAndZoom(new T.LngLat(first.lng, first.lat), 17)
      this.map.addControl(new T.Control.Zoom())
      this.map.addControl(new T.Control.Scale())

      const path = []
      this.points.forEach(point => {
        if (!point.lng || !point.lat) return
        const display = storeToTianditu(point.lng, point.lat, this.storeCoord)
        const lnglat = new T.LngLat(display.lng, display.lat)
        const marker = new T.Marker(lnglat)
        this.map.addOverLay(marker)
        this.markers.push(marker)
        path.push(lnglat)
      })

      if (path.length > 1) {
        this.polyline = new T.Polyline(path, {
          color: '#3777FF',
          weight: 5,
          opacity: 0.9
        })
        this.map.addOverLay(this.polyline)
      }
    },
    clearOverlays() {
      if (!this.map) {
        this.markers = []
        this.polyline = null
        return
      }
      this.markers.forEach(m => this.map.removeOverLay(m))
      if (this.polyline) {
        this.map.removeOverLay(this.polyline)
      }
      this.markers = []
      this.polyline = null
    }
  }
}
</script>

<style scoped>
.map-container {
  height: 600px;
  width: 100%;
}
</style>
